import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageSlider({ images = [], alt = "Car", testId, aspect = "aspect-[4/3]" }) {
  const [idx, setIdx] = useState(0);
  if (!images.length) {
    return <div className={`w-full ${aspect} bg-[#1A1A1A]`} />;
  }
  const next = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    setIdx((i) => (i + 1) % images.length);
  };
  const prev = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    setIdx((i) => (i - 1 + images.length) % images.length);
  };
  return (
    <div className={`relative w-full ${aspect} overflow-hidden bg-[#1A1A1A] group`} data-testid={testId}>
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`${alt} ${i + 1}`}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
      {images.length > 1 && (
        <>
          <button
            onClick={prev}
            data-testid={`${testId}-prev`}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full glass text-[#F5F5DC] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#DC143C] hover:border-[#DC143C]"
            aria-label="Previous image"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={next}
            data-testid={`${testId}-next`}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full glass text-[#F5F5DC] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#DC143C] hover:border-[#DC143C]"
            aria-label="Next image"
          >
            <ChevronRight size={18} />
          </button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {images.map((_, i) => (
              <span key={`dot-${i}`} className={`slider-dot ${i === idx ? "active" : ""}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
